// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"rotaryEncoder_wrapper__1O8uP","rotaryEncoder":"rotaryEncoder_rotaryEncoder__1cWB3","dot":"rotaryEncoder_dot__2nwNR"};